export default {
  meta: {
    title: '点位测评模型配置',
    parentPath: ['/location'],
    breadcrumbs: {
      path: ['/location/pointmodel'],
      name: ['点位测评模型配置'],
    },
  },
};
